/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect } from "react";
import { fileTypes, TableController } from "../../../components/Constant";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useValidationMessages } from "../../../hooks/useValidationMessages";
import { UPLOAD_IMAGE } from "../../../repository/image_upload_repo";
import moment from "moment-timezone";
import { VENDOR_ADD_PAST_EVENT, VENDOR_DELETE_PAST_EVENT, VENDOR_EDIT_PAST_EVENT, VENDOR_PAST_EVENT_LIST } from "../../../repository/past_event_repo";

export const MAX_PAST_EVENT_MEDIA = 10

export default function usePastEvent() {

    const { t } = useTranslation();
    const { requiredMessage, requiredDate } = useValidationMessages()
    const [controller, setController] = useState(TableController)
    const [totalCount, setTotalCount] = useState(0);
    const [pastEventInput, setPastEventInput] = useState({ name: '', eventDate: null, images: [] })
    const [error, setError] = useState({})
    const [openModal, setOpenModal] = useState({
        deletePastEvent: false,
        addPastEvent: false,
        data: null
    })
    const [spinner, setSpinner] = useState(false)
    const [filter, setFilter] = useState({
        search: "",
        disable_button: true,
    })
    const [listData, setListData] = useState([])
    const uploadImgRef = useRef(null)

    useEffect(() => {
        getPastEventList()
    }, [controller])

    const getPastEventList = async () => {
        try {
            let payload = {
                count: controller.rowsPerPage,
                page: controller.page,
                search: filter.search,
            }
            setSpinner(true)
            let response = await VENDOR_PAST_EVENT_LIST(payload)
            setListData(response?.data)
            setTotalCount(response?.totalCount)
        } catch (error) {
            setListData([])
            setTotalCount(0)
        }
        setSpinner(false)
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPastEventInput((pre) => ({ ...pre, [name]: value }))
        setError((pre) => {
            delete pre[name];
            return { ...pre };
        });
    }
    const handleBlur = (event) => {
        const { name, value } = event.target
        !value?.trim()?.length && setError((pre) => ({ ...pre, [name]: requiredMessage(t("validation.name")) }))
    }
    const HandleSearch = () => {
        setController((pre) => ({ ...pre, searchPage: pre?.page, page: 1 }))
    }
    const handleChangeFilter = (event, disable = false) => {
        const { name, value } = event.target
        setFilter((pre) => ({ ...pre, disable_button: disable, [name]: value }))
    }
    const reset = () => {
        setController((pre) => ({ ...pre, page: pre.searchPage ?? pre.page, searchPage: null, }))
        setFilter((prev) => ({ ...prev, search: "", disable_button: true }))
    }

    const isValid = () => {
        const errorObj = {};
        if (!pastEventInput?.name?.trim()) {
            errorObj['name'] = requiredMessage(t("validation.name"));
        }
        if (!pastEventInput?.eventDate) {
            errorObj['eventDate'] = requiredDate(t("pastEvent.eventDate"));
        } else if (moment(pastEventInput.eventDate).isAfter(moment(), 'day')) {
            errorObj['eventDate'] = t("pastEvent.futureDateNotAllowed");
        }
        if (!pastEventInput?.images?.length) {
            errorObj['images'] = t("pastEvent.mediaRequired");
        }
        setError(errorObj);
        return Object.keys(errorObj).length === 0;
    };

    const TableHeadData = [
        { label: '#' },
        { label: `${t("pastEvent.media")}` },
        { label: `${t("tableTitle.name")}` },
        { label: `${t("pastEvent.eventDate")}` },
        { label: `${t("tableTitle.status")}` },
        { label: `${t("tableTitle.action")}` },
    ]

    const clear = () => {
        setPastEventInput({ name: '', eventDate: null, images: [] });
        setError({})
    }
    const handleOpenModal = (type, data = null) => {
        if (type === "addPastEvent") {
            if (data) {
                setPastEventInput({
                    name: data?.name || '',
                    eventDate: data?.eventDate ? new Date(data?.eventDate) : null,
                    images: data?.images || [],
                });
                setError({})
            } else clear()
        }
        setOpenModal((prev) => ({ ...prev, data: data, [type]: true }));
    };
    const handleClosedModal = (type) => {
        if (type === "addPastEvent") clear()
        setOpenModal((pre) => ({ ...pre, data: null, [type]: false }))
    }

    const handlePagination = (obj) => {
        setController(obj)
    }

    const handleAddSubmit = async (event) => {
        event.preventDefault()
        if (!isValid()) return
        setSpinner(true)
        let payload = {
            name: pastEventInput?.name?.trim(),
            eventDate: moment(pastEventInput?.eventDate).startOf('day'),
            images: pastEventInput?.images,
        }
        if (openModal.data?._id) payload.id = openModal.data?._id
        try {
            let response = openModal.data?._id ? await VENDOR_EDIT_PAST_EVENT(payload) : await VENDOR_ADD_PAST_EVENT(payload)
            handleClosedModal('addPastEvent')
            getPastEventList()
            toast.success(response.message)
        } catch (error) {
            toast.error(error.message)
        }
        setSpinner(false)
    }

    // upload one by one so we never cross the per request file limit of the upload api
    const uploadMedia = async (fileList) => {
        const files = Array.from(fileList?.length !== undefined ? fileList : [fileList]).filter(Boolean)
        if (!files.length) return;

        const remaining = MAX_PAST_EVENT_MEDIA - (pastEventInput?.images?.length || 0)
        if (remaining <= 0) {
            toast.error(t("pastEvent.maxMediaLimit"))
            return
        }
        if (files.length > remaining) toast.error(t("pastEvent.maxMediaLimit"))

        const validFiles = files.slice(0, remaining).filter((file) => {
            const isValidType = fileTypes.Img_Type.includes(file.type) || fileTypes.video_Type.includes(file.type)
            if (!isValidType) toast.error(`${file.name}: ${t("validation.imageAndVideo")}`)
            return isValidType
        })

        setSpinner(true);
        for (const file of validFiles) {
            const fd = new FormData();
            fd.append('type', "PASTEVENTIMG");
            fd.append('files', file);
            try {
                const response = await UPLOAD_IMAGE(fd);
                const uploadedName = response?.data?.[0]?.db_name;
                if (!uploadedName) {
                    toast.error(response?.message || `${file.name}`)
                    continue
                }
                setPastEventInput((prev) => ({ ...prev, images: [...(prev?.images || []), uploadedName] }));
                setError((prev) => {
                    delete prev["images"];
                    return { ...prev };
                });
            } catch (error) {
                toast.error(error.message);
            }
        }
        setSpinner(false);
        if (uploadImgRef.current) uploadImgRef.current.value = "";
    };

    const removeMedia = (index) => {
        setPastEventInput((prev) => ({ ...prev, images: prev?.images?.filter((_, i) => i !== index) }))
    }

    const handleDelete = async (event) => {
        if (event === "YES") {
            setSpinner(true)
            try {
                let response = await VENDOR_DELETE_PAST_EVENT({ id: openModal.data?._id })
                toast.success(response.message)
                if (listData?.length === 1 && controller.page > 1) {
                    setController((prev) => ({ ...prev, page: prev.page - 1 }))
                } else {
                    getPastEventList()
                }
                handleClosedModal("deletePastEvent")
            } catch (error) {
                toast.error(error.message);
            }
            setSpinner(false)
        } else {
            handleClosedModal("deletePastEvent")
        }
    }

    return {
        methods: {
            handlePagination,
            handleClosedModal,
            handleOpenModal,
            handleInputChange,
            handleBlur,
            handleAddSubmit,
            handleDelete,
            uploadMedia,
            removeMedia,
            HandleSearch,
            handleChangeFilter,
            reset,
        },
        data: {
            TableHeadData,
            controller,
            totalCount,
            openModal,
            uploadImgRef,
            pastEventInput,
            error,
            spinner,
            listData,
            filter,
        },
    }
}
